// start, target, optimalPathLength
export const WORD_PAIRS = [
	['žiba', 'rūkė', 5], // žibą, ribą, rūbą, rūką, rūkė
	['balo', 'lūpa', 5], // balą, lalą, lapą, lūpą, lūpa
	['toli', 'nyko', 4], // tyli, tyki, nyki, nyko
	['lokė', 'gira', 5], // lopė, lipė, lipa, lira, gira
	['dūko', 'vėžė', 5], // dūmo, dūmė, dėmė, vėmė, vėžė
	['aižo', 'rasa', 6], // tižo, tiso, biso, baso, basa, rasa
	['alga', 'bazė', 7], // auga, auka, buka, bukė, burė, barė, bazė
	['kovė', 'tara', 5], // korė, korę, karę, tarę, tara
	['goži', 'ardo', 5], // giži, aiži, aižo, aido, ardo
	['naša', 'dėti', 4], // nata, data, dėta, dėti
	['rakė', 'tyli', 4], // raki, rali, tali, tyli
	['lapė', 'pūra', 5], // tapė, tarė, tara, para, pūra
	['rasa', 'pūtė', 4], // rata, rūta, pūta, pūtė
	['deda', 'gimė', 5], // dedu, didu, gidu, gidė, gimė
	['pyko', 'lava', 4], // pako, lako, laka, lava
	['lama', 'riko', 4], // laka, lako, rako, riko
	['zuja', 'mirė', 6], // guja, gija, gira, girt, mirt, mirė
	['rūgo', 'darė', 5], // rago, ražo, dažo, dažė, darė
	['sakė', 'peša', 5], // šakė, šašė, pašė, pešė, peša
	['lokė', 'tąsa', 7], // lakė, laką, taką, tyką, tysą, tąsą, tąsa
	['geba', 'budo', 4], // guba, gubo, gudo, budo
	['tyso', 'vadė', 5], // tyro, tyrė, tarė, varė, vadė
	['gydo', 'pusė', 5], // gudo, guro, puro, purė, pusė
	['vėsa', 'kabė', 5], // vėsi, kėsi, kasi, kabi, kabė
	['žižė', 'sako', 5], // žilė, žalė, salė, sakė, sako
	['tepė', 'gina', 4], // tepa, tena, tina, gina
	['gina', 'tuko', 4], // tina, tino, tuno, tuko
	['lipa', 'tynė', 5], // lira, lyra, tyra, tyna, tynė
	['rūko', 'gobė', 6], // rūkė, rėkė, rėžė, rožė, gožė, gobė
	['buko', 'koja', 5], // kuko, kupo, kupa, kopa, koja
	['čeža', 'sirė', 6], // keža, kežo, kero, kiro, siro, sirė
	['toli', 'vypo', 5], // tyli, tyki, tyko, vyko, vypo
	['salė', 'tiko', 4], // sakė, sako, tako, tiko
	['lyja', 'gali', 4], // gyja, gyji, gyli, gali
	['šulė', 'lydo', 5], // šulą, šylą, šydą, lydą, lydo
	['dama', 'nori', 5], // daga, naga, nagi, nari, nori
	['uodė', 'vypo', 6], // uodo, rodo, roko, voko, vyko, vypo
	['pūra', 'žolė', 5], // pėra, pėrė, žėrė, žėlė, žolė
	['seka', 'žilė', 5], // sekė, sakė, salė, žalė, žilė
	['tėtė', 'žalo', 5], // mėtė, matė, malė, žalė, žalo
	['nata', 'dėžė', 5], // data, datą, dažą, dažė, dėžė
	['lėpo', 'darė', 5], // lapo, lapė, tapė, tarė, darė
	['kyša', 'matė', 5], // kyla, kala, kalė, katė, matė
	['sėja', 'mykė', 5], // sėji, syji, syki, myki, mykė
	['būti', 'viso', 4], // būto, bito, biso, viso
	['tapo', 'bėra', 5], // tapė, tarė, barė, bėrė, bėra
	['motė', 'duja', 6], // gotė, gožė, goža, guža, guja, duja
	['gyja', 'tęsė', 6], // gyji, gysi, rysi, ręsi, tęsi, tęsė
	['gyrė', 'rega', 5], // dyrė, dygė, degė, dega, rega
	['manė', 'arfa', 7], // manų, madų, midų, aidų, ardų, arda, arfa
	['nyko', 'putė', 5], // pyko, pako, pato, puto, putė
	['goži', 'laka', 5], // gobi, lobi, labi, laki, laka
	['iria', 'nėrė', 8], // aria, arta, auta, puta, putė, purė, pėrė, nėrė
	['lėmė', 'nors', 6], // lėmę, lėkę, lokę, nokę, norę, nors
	['tęsė', 'byla', 6], // tąsė, tąsą, tysą, tylą, bylą, byla
	['bėgi', 'moko', 5], // bėgo, mėgo, mėto, moto, moko
	['ritė', 'jodo', 5], // rito, kito, kido, kodo, jodo
	['dilo', 'vožė', 5], // dilų, vilų, volų, volė, vožė
	['tūno', 'uola', 5], // tūnu, tūlu, tolu, uolu, uola
	['dėlė', 'rudo', 5], // gėlė, gulė, gudė, rudė, rudo
	['dėžė', 'kaso', 5], // dažė, dažo, lažo, laso, kaso
	['vijo', 'zona', 6], // vipo, tipo, tino, tono, tona, zona
	['gira', 'segė', 5], // gera, gere, gege, gegė, segė
	['žudė', 'pina', 5], // gudė, gidė, ginė, gina, pina
	['pūga', 'žolė', 6], // pūra, pėra, pėrė, žėrė, žėlė, žolė
	['moka', 'žūti', 5], // mota, bota, būta, žūta, žūti
	['žūva', 'šipo', 6], // žava, žala, žalo, žilo, šilo, šipo
	['čižo', 'mena', 5], // tižo, težo, teža, tena, mena
	['matė', 'arba', 7], // matų, madų, midų, aidų, ardų, arda, arba
	['sija', 'veto', 5], // sijo, rijo, rito, reto, veto
	['pusė', 'maga', 4], // musė, mugė, magė, maga
	['lodė', 'supo', 4], // lodo, sodo, sopo, supo
	['rėmė', 'kali', 5], // vėmė, vėlė, valė, kalė, kali
	['lyso', 'košė', 5], // lydo, lydė, lodė, lošė, košė
	['tyla', 'narė', 4], // tyra, tyrė, tarė, narė
	['aria', 'dėjo', 7], // arta, auta, auto, aušo, dušo, dujo, dėjo
	['aižė', 'teka', 5], // tižė, tiži, teži, teki, teka
	['moti', 'vėso', 4], // moto, mėto, vėto, vėso
	['tėra', 'gotė', 6], // bėra, bėrų, borų, botų, gotų, gotė
	['pūdo', 'manė', 4], // pado, pano, mano, manė
	['mykė', 'dujo', 6], // myki, dyki, dyši, duši, dušo, dujo
	['bitė', 'tyli', 6], // bitu, mitu, milu, mylu, myli, tyli
	['riba', 'gulė', 5], // žiba, žibė, žilė, gilė, gulė
	['žymė', 'auna', 6], // žynė, tynė, tyną, tuną, auną, auna
	['neva', 'rūgo', 5], // nava, naga, nago, rago, rūgo
	['soja', 'rėžė', 4], // sėja, rėja, rėža, rėžė
	['rasi', 'muro', 4], // rusi, ruso, muso, muro
	['soda', 'tarp', 5], // sora, pora, para, tara, tarp
	['pila', 'vogė', 5], // žila, žilė, žolė, volė, vogė
	['lupo', 'kūlė', 5], // kupo, kuko, kūko, kūkė, kūlė
	['arba', 'vyto', 7], // arta, auta, auto, buto, bato, vato, vyto
	['menė', 'duso', 5], // meno, mero, muro, muso, duso
	['pora', 'šipo', 6], // poro, pero, kero, kepo, šepo, šipo
	['gavo', 'tąsė', 6], // gavi, guvi, gusi, tusi, tąsi, tąsė
	['šepo', 'katė', 5], // šapo, šapu, kapu, katu, katė
	['ganė', 'dūda', 6], // gana, gena, gera, dera, deda, dūda
	['teka', 'būgo', 5], // teta, tūta, būta, būto, būgo
	['kerė', 'vėsa', 5], // kert, vert, vest, vėst, vėsa
	['paša', 'kero', 5], // para, parą, karą, karo, kero
	['šilo', 'pešė', 5], // žilo, žilė, želė, pelė, pešė
	['dyko', 'volė', 4], // doko, voko, volo, volė
	['movė', 'varo', 4], // morė, vorė, varė, varo
	['kalė', 'lupa', 4], // kala, kapa, kupa, lupa
	['lydė', 'kopa', 4], // lodė, lopė, kopė, kopa
	['pėda', 'gynė', 4], // pėdė, pydė, gydė, gynė
	['suso', 'uola', 6], // susi, busi, bosi, uosi, uoli, uola
	['šaža', 'gyvi', 6], // šaka, šoka, šova, šyva, gyva, gyvi
	['teko', 'kaba', 4], // tako, kako, kabo, kaba
	['putė', 'virš', 5], // purė, purk, pirk, virk, virš
	['iena', 'gidė', 4], // gena, gina, ginė, gidė
	['lyga', 'dubo', 6], // lyja, gyja, guja, gujo, gubo, dubo
	['peni', 'vypo', 5], // pyni, pypi, pypk, vypk, vypo
	['kepa', 'tėtė', 5], // keta, kata, katė, kėtė, tėtė
	['nyro', 'kaba', 4], // naro, karo, kabo, kaba
	['būna', 'įėjo', 6], // būda, bėda, įėda, įėdę, įėję, įėjo
	['žagė', 'vyti', 5], // žagų, vagų, vatų, vytų, vyti
	['kava', 'rusė', 4], // kasa, rasa, rusa, rusė
	['niša', 'rūpi', 5], // niši, tiši, tūši, tūpi, rūpi
	['byra', 'ropė', 6], // lyra, lira, lipa, lipė, lopė, ropė
	['gybo', 'šaka', 6], // gybę, gylę, galę, šalę, šakę, šaka
	['pina', 'lydė', 5], // pila, pyla, pylė, pydė, lydė
	['žara', 'vyko', 5], // žyra, žyri, vyri, vyro, vyko
	['dozė', 'žiba', 6], // dobė, dobt, dėbt, žėbt, žibt, žiba
	['burė', 'čižo', 6], // burę, birę, nirę, nižę, čižę, čižo
	['gano', 'dūda', 6], // pano, pado, pūdo, pūdą, dūdą, dūda
	['tyrė', 'saga', 6], // tyrų, tarų, narų, nagų, naga, saga
	['vena', 'tižo', 4], // tena, tina, tino, tižo
	['sūdo', 'vila', 6], // sūro, siro, sijo, vijo, vija, vila
	['cypė', 'kuto', 6], // cypt, capt, kapt, kapo, kupo, kuto
	['aušo', 'myli', 5], // aulo, mulo, molo, moli, myli
	['pėrė', 'lodo', 5], // pėdė, pydė, lydė, lodė, lodo
	['bijo', 'popa', 5], // biro, boro, poro, pora, popa
	['kuto', 'uola', 5], // kutų, kotų, uotų, uolų, uola
	['žėlė', 'dužo', 5], // dėlė, dėžė, dažė, dažo, dužo
	['varė', 'migo', 4], // varo, maro, mago, migo
	['pūdė', 'tarp', 5], // pūdą, pūrą, parą, tarą, tarp
	['suka', 'eilė', 5], // sula, gula, gulė, gilė, eilė
	['riša', 'tūpė', 5], // riši, tiši, tūši, tūpi, tūpė
	['tynė', 'guli', 4], // tyni, tyli, tuli, guli
	['teta', 'zujo', 6], // reta, ryta, ryja, ruja, zuja, zujo
	['dūrė', 'kaba', 4], // darė, karė, kabė, kaba
	['rijo', 'manė', 5], // rito, rato, mato, mano, manė
	['mėta', 'kako', 4], // mėto, mato, mako, kako
	['regi', 'mažo', 4], // ragi, rago, ražo, mažo
	['kišo', 'pusė', 5], // kiro, kuro, puro, purė, pusė
	['davė', 'rūgi', 5], // įavė, įavi, ravi, ragi, rūgi
	['bėga', 'vežė', 5], // bėda, beda, veda, vedė, vežė
	['sėdo', 'gyrė', 5], // pėdo, pėdė, pėrė, gėrė, gyrė
	['šovė', 'fėja', 6], // šovų, rovų, rojų, rėjų, fėjų, fėja
	['žudo', 'vaga', 4], // žado, vado, vada, vaga
	['filė', 'šaža', 6], // finė, minė, manė, mažė, maža, šaža
	['zona', 'želė', 6], // zonų, ponų, penų, pelų, pelė, želė
	['kyli', 'rožė', 5], // vyli, vylė, vyžė, vožė, rožė
	['bala', 'aižo', 6], // balu, galu, gilu, gižu, aižu, aižo
	['neto', 'gidė', 4], // geto, gedo, gido, gidė
	['mada', 'nešė', 5], // maga, naga, naša, neša, nešė
	['pylė', 'sėdi', 5], // pydė, pydo, pėdo, sėdo, sėdi
	['lijo', 'kūrė', 5], // bijo, biro, būro, būrė, kūrė
	['gidė', 'joti', 5], // gide, gode, gote, jote, joti
	['dėjo', 'įarė', 4], // dėro, daro, darė, įarė
	['boti', 'gilė', 6], // bosi, kosi, kisi, kili, gili, gilė
	['kabė', 'toga', 6], // kabą, kaną, taną, toną, tona, toga
	['pūti', 'mišo', 5], // pūri, mūri, mūši, miši, mišo
	['veda', 'mirė', 5], // vena, mena, menė, minė, mirė
	['dygo', 'muša', 5], // dygę, mygę, mugę, mušę, muša
	['kabo', 'lokė', 4], // kako, lako, lakė, lokė
	['gižo', 'vapa', 5], // gijo, gija, gaja, vaja, vapa
	['kaži', 'suko', 4], // kuži, kuki, suki, suko
	['beda', 'pūtė', 4], // būda, būta, pūta, pūtė
	['bazė', 'arda', 5], // badė, budė, audė, ardė, arda
	['duso', 'anka', 5], // dusų, ausų, aukų, auka, anka
	['narė', 'kimo', 4], // karė, karo, kiro, kimo
	['kyšo', 'mada', 5], // kyša, kyla, kala, mala, mada
	['dobė', 'peri', 4], // dobi, dori, deri, peri
	['taip', 'seno', 6], // tarp, tari, tani, teni, seni, seno
	['vyko', 'movė', 4], // voko, vokė, mokė, movė
	['rėžė', 'tino', 5], // rėkė, rikė, riko, tiko, tino
	['pyla', 'tąso', 5], // pylą, tylą, tysą, tąsą, tąso
	['magė', 'pūva', 6], // mago, mato, pato, pūto, pūta, pūva
	['loti', 'mėgo', 4], // loto, lėto, mėto, mėgo
	['mynė', 'bėda', 5], // pynė, pydė, pėdė, pėda, bėda
	['dėvi', 'budė', 5], // dėsi, dusi, busi, budi, budė
	['kako', 'šuva', 6], // kuko, kuto, šuto, šutų, šuvų, šuva
	['moto', 'kabė', 4], // mato, matė, katė, kabė
	['lyta', 'tepė', 5], // ryta, reta, teta, tepa, tepė
	['niro', 'sėja', 4], // siro, sijo, sija, sėja
	['pana', 'kekė', 5], // kana, kapa, kepa, kepė, kekė
	['pešė', 'dubo', 6], // pešt, pert, purt, durt, dubt, dubo
	['rašė', 'gyja', 5], // rašą, rają, raja, ryja, gyja
	['gula', 'rūkė', 5], // gulė, gudė, rudė, rūdė, rūkė
	['kovė', 'niro', 5], // korė, korę, norę, nirę, niro
	['gulė', 'dyri', 4], // guli, guri, duri, dyri
	['gėda', 'žilė', 4], // gėla, gėlė, žėlė, žilė
	['lava', 'duso', 6], // laša, laši, daši, duši, dušo, duso
	['kūrė', 'rimo', 5], // kūkė, kūko, kūmo, kimo, rimo
	['segi', 'ližė', 6], // seki, leki, lepi, lipi, lipė, ližė
	['bado', 'guli', 4], // balo, galo, gali, guli
	['poza', 'šakė', 6], // pozų, popų, papų, šapų, šakų, šakė
	['teža', 'kimo', 5], // težo, kežo, kero, kiro, kimo
	['ugdė', 'myli', 5], // uodė, uodi, uoli, moli, myli
	['dūko', 'lesė', 5], // dūki, lūki, leki, lesi, lesė
	['kyla', 'pūdo', 5], // pyla, pylę, pydę, pūdę, pūdo
	['veja', 'pūti', 5], // veji, veri, peri, pūri, pūti
	['gotė', 'žydi', 5], // gotą, gytą, gydą, žydą, žydi
	['būda', 'sesė', 6], // beda, veda, vena, sena, senė, sesė
	['loto', 'paša', 5], // lota, loma, lama, laša, paša
	['jodė', 'sava', 5], // jovė, kovė, kova, kava, sava
	['veža', 'muro', 5], // vežk, verk, merk, mero, muro
	['gydė', 'mojo', 5], // gydo, godo, jodo, jojo, mojo
	['gama', 'žudo', 5], // guma, gura, guro, gudo, žudo
	['rožė', 'pyni', 5], // rodė, rydė, pydė, pynė, pyni
	['joti', 'degė', 5], // jotų, jogų, dogų, degų, degė
	['košė', 'tįsa', 6], // koši, kosi, kąsi, tąsi, tąsa, tįsa
	['žalo', 'būda', 4], // balo, bado, būdo, būda
	['rišo', 'mokė', 4], // riko, roko, moko, mokė
	['gyvi', 'narė', 4], // gavi, gari, nari, narė
	['žynė', 'puma', 6], // gynė, gylė, gulė, gula, guma, puma
	['ropė', 'mažo', 5], // rolė, molė, malė, mažė, mažo
	['orus', 'ežia', 6], // irus, ižus, ūžus, ūžis, ūžia, ežia
	['lėlė', 'rūgi', 6], // lėkė, rėkė, rėkę, rūkę, rūgę, rūgi
	['rūkė', 'gula', 5], // rūdė, rudė, gudė, gulė, gula
	['laso', 'želė', 5], // baso, balo, žalo, žalė, želė
	['danė', 'sėdi', 6], // daną, datą, dėtą, dėti, sėti, sėdi
	['loma', 'gūžė', 6], // lomą, lopą, lūpą, lūžą, gūžą, gūžė
	['moko', 'bara', 4], // mako, bako, baro, bara
	['darė', 'aria', 7], // dari, diri, didi, aidi, aida, arda, aria
	['gyti', 'uodė', 5], // gytu, gotu, godu, uodu, uodė
	['katė', 'budo', 5], // karė, barė, baro, bado, budo
	['sula', 'degė', 5], // gula, guga, gugė, gegė, degė
	['degė', 'vyža', 4], // dygė, dyžė, dyža, vyža
	['vogė', 'gyja', 6], // vogį, votį, vytį, vyta, gyta, gyja
	['badė', 'liga', 6], // badų, batų, bitų, litų, ligų, liga
	['lypi', 'kaba', 5], // lupi, lupa, kupa, kapa, kaba
	['kopa', 'žino', 6], // kapa, kapo, tapo, tipo, tino, žino
	['kasa', 'uodė', 5], // kasi, kosi, uosi, uodi, uodė
	['veša', 'lodo', 5], // vešą, vedą, ledą, lodą, lodo
	['raja', 'peni', 5], // gaja, gana, gena, geni, peni
	['duba', 'pešė', 6], // dubi, duri, deri, peri, peši, pešė
	['bėrė', 'ardo', 5], // burė, budė, audė, ardė, ardo
	['gėrė', 'pyni', 4], // gyrė, gynė, pynė, pyni
	['sava', 'mėto', 5], // savo, sako, mako, mato, mėto
	['bėda', 'guli', 4], // gėda, gėla, gėli, guli
	['kali', 'gėrė', 4], // gali, gėli, gėlė, gėrė
	['varo', 'eglė', 6], // garo, galo, galė, gilė, eilė, eglė
	['mena', 'aižo', 5], // mina, minę, ainę, aižę, aižo
	['kepo', 'nagi', 5], // kepi, keši, neši, naši, nagi
	['dėdė', 'aižo', 6], // dėlė, žėlė, žilė, žižė, aižė, aižo
	['tyka', 'darė', 4], // tyra, tyrė, dyrė, darė
	['žuvo', 'arba', 6], // puvo, puto, auto, auta, arta, arba
	['aibė', 'nagi', 6], // aižė, aiži, niži, niši, naši, nagi
	['budo', 'iria', 6], // buko, buka, auka, arka, aria, iria
	['mėgo', 'guma', 5], // mago, maga, gaga, guga, guma
	['tada', 'rovė', 5], // kada, kava, kova, kovė, rovė
	['lūžo', 'soja', 5], // lūžę, ložę, loję, loja, soja
	['bedė', 'pala', 5], // badė, badų, balų, bala, pala
	['mušė', 'sako', 5], // mušt, mukt, muko, mako, sako
	['lydi', 'mišo', 5], // lyši, kyši, kiši, kišo, mišo
	['muro', 'regi', 5], // mero, meto, meti, reti, regi
	['čekė', 'šyla', 6], // čeką, teką, tyką, tylą, tyla, šyla
	['suma', 'vadė', 5], // sula, sala, salė, valė, vadė
	['figa', 'dažo', 6], // fuga, guga, guža, gužo, dužo, dažo
	['tepa', 'jodė', 6], // tena, tona, tone, jone, jode, jodė
	['žemė', 'auga', 7], // žemi, žeri, geri, gera, gura, aura, auga
	['dyrė', 'gija', 5], // dynė, gynė, ginė, gina, gija
	['sekė', 'vyti', 4], // seki, syki, syti, vyti
	['jojo', 'rasa', 5], // jojų, rojų, rajų, raja, rasa
	['tapė', 'riko', 4], // tapo, tako, rako, riko
	['ryti', 'vėsa', 4], // vyti, vysi, vėsi, vėsa
	['supo', 'dėžė', 6], // rupo, rupę, rėpę, rėžę, dėžę, dėžė
	['gūžė', 'laka', 5], // gožė, ložė, lokė, lakė, laka
	['musė', 'gana', 4], // masė, manė, ganė, gana
	['auga', 'šoko', 6], // augo, aulo, šulo, šilo, šiko, šoko
	['žiro', 'aria', 6], // kiro, kido, aido, ardo, arda, aria
	['menk', 'ryja', 5], // mena, meta, reta, ryta, ryja
	['irus', 'ūžia', 4], // ižus, ūžus, ūžis, ūžia
	['kėdė', 'puro', 4], // pėdė, pėrė, purė, puro
	['mokė', 'byra', 5], // moki, myki, myri, byri, byra
	['vaga', 'gyrė', 5], // gaga, gana, ganė, gynė, gyrė
	['karo', 'pina', 4], // kiro, kino, pino, pina
	['pašo', 'gėrė', 5], // palo, galo, galė, gėlė, gėrė
	['dera', 'rodė', 5], // deda, dūda, rūda, rūdė, rodė
	['rovė', 'gydo', 4], // rodė, rydė, rydo, gydo
	['sėdi', 'dilo', 5], // sėdę, dėdę, dėlę, dilę, dilo
	['želė', 'vyti', 4], // velė, veli, vyli, vyti
	['kaip', 'pešė', 6], // kais, keis, keik, peik, pešk, pešė
	['tiko', 'zyzė', 5], // tyko, tyks, zyks, zykė, zyzė
	['vypo', 'žėrė', 4], // vėpo, vėpė, vėrė, žėrė
	['anka', 'bėgo', 7], // auka, buka, buko, budo, būdo, būgo, bėgo
	['sagė', 'ruja', 5], // ragė, ragą, rają, rują, ruja
	['mugė', 'tūno', 5], // magė, manė, mano, tano, tūno
	['uoga', 'pūdė', 5], // uogė, uodė, rodė, rūdė, pūdė
	['peša', 'toli', 5], // peši, teši, tūši, tūli, toli
	['šūka', 'jodė', 5], // šoka, šova, šovė, jovė, jodė
	['tema', 'sirė', 6], // tepa, tepų, tipų, tirų, sirų, sirė
	['mėžė', 'lijo', 5], // mėtė, mėto, lėto, lito, lijo
	['lėto', 'gedi', 5], // lėti, mėti, meti, medi, gedi
	['mėsa', 'lošė', 6], // mėsė, masė, lasė, lapė, lopė, lošė
	['gožė', 'vypo', 5], // vožė, vėžė, vėpė, vėpo, vypo
	['tižo', 'pala', 5], // tipo, tapo, papo, palo, pala
	['tyko', 'dėžė', 5], // tykę, dykę, dyžę, dėžę, dėžė
	['vyti', 'žolė', 4], // vyli, vylė, volė, žolė
	['anga', 'šalo', 5], // auga, augo, aulo, šulo, šalo
	['dūmė', 'boti', 5], // domė, domi, lomi, loti, boti
	['dubo', 'byra', 5], // dubi, bubi, buri, byri, byra
	['puvo', 'kūlė', 5], // puto, putė, pūtė, kūtė, kūlė
	['mėmė', 'lūpa', 6], // lėmė, lėmę, lėpę, lupę, lupa, lūpa
	['rodė', 'lyja', 5], // rydė, lydė, lydu, lyju, lyja
	['byla', 'dūrė', 4], // dyla, dūla, dūlė, dūrė
	['dažė', 'iena', 5], // danė, ganė, gana, gena, iena
	['sėti', 'kalė', 5], // mėti, mėtė, matė, malė, kalė
	['šoka', 'fazė', 6], // šoke, šake, bake, baze, bazė, fazė
	['dyro', 'tada', 4], // tyro, tyra, tara, tada
	['gijo', 'peri', 5], // giją, girą, gerą, perą, peri
	['vipo', 'loma', 5], // lipo, lijo, lojo, loja, loma
	['mano', 'korė', 4], // maro, karo, karė, korė
	['mito', 'žara', 5], // mato, maro, marų, žarų, žara
	['pypė', 'riša', 6], // pydė, rydė, rydą, ridą, rišą, riša
	['dora', 'lijo', 5], // doro, boro, biro, bijo, lijo
	['dujo', 'tezė', 6], // dują, deją, depą, tepą, tepė, tezė
	['merė', 'kimo', 4], // kerė, kero, kiro, kimo
	['bėra', 'putė', 4], // pėra, pėrė, purė, putė
	['auka', 'gano', 5], // aura, gura, guro, garo, gano
	['muša', 'šėrė', 6], // muši, muri, guri, gėri, gėrė, šėrė
	['sirė', 'puma', 6], // sirą, girą, gurą, gumą, pumą, puma
	['pūva', 'tįso', 6], // pūvi, pūsi, žūsi, žįsi, tįsi, tįso
	['data', 'nyro', 5], // datų, darų, daro, naro, nyro
	['eiga', 'dujo', 6], // figa, fuga, guga, guja, duja, dujo
	['mato', 'šąla', 5], // mėto, mėlo, šėlo, šėla, šąla
	['įėjo', 'figa', 7], // dėjo, dujo, gujo, gugo, guga, fuga, figa
	['orda', 'mažo', 7], // arda, aida, aidų, midų, madų, mažų, mažo
	['senė', 'rodo', 5], // seno, geno, gedo, godo, rodo
	['tara', 'žūti', 5], // para, pūra, pūta, žūta, žūti
	['viso', 'gali', 4], // visi, vili, vali, gali
	['lesa', 'dužo', 6], // lesą, lasą, lažą, dažą, dažo, dužo
	['vėpo', 'rega', 5], // vėto, veto, reto, reta, rega
	['suko', 'bedė', 4], // buko, bukė, budė, bedė
	['bąla', 'dėdė', 6], // šąla, šėla, šėle, dėle, dėde, dėdė
	['rusė', 'tūžo', 5], // ruso, rūso, rūbo, tūbo, tūžo
	['sėmė', 'zuja', 6], // dėmė, dėmi, dumi, duji, zuji, zuja
	['kybo', 'pelė', 5], // kybą, kylą, pylą, pelą, pelė
	['nyri', 'pūtė', 5], // dyri, dūri, pūri, pūti, pūtė
	['gobi', 'dygo', 5], // gobų, gogų, dogų, dogo, dygo
	['rida', 'gybo', 5], // ridą, rydą, gydą, gydo, gybo
	['tolo', 'sagė', 4], // solo, salo, salė, sagė
	['ryja', 'vėmė', 5], // rėja, rėža, rėžė, vėžė, vėmė
	['vija', 'kūlė', 5], // vaja, vajė, valė, kalė, kūlė
	['liko', 'bara', 4], // lako, bako, baro, bara
	['žilo', 'lesė', 6], // tilo, tiso, tyso, lyso, lysė, lesė
	['žydi', 'pūra', 5], // žydą, pydą, pūdą, pūrą, pūra
	['puta', 'kėdė', 5], // putė, pūtė, kūtė, kėtė, kėdė
	['rega', 'ardo', 6], // reta, rita, rida, aida, aido, ardo
	['segė', 'riba', 5], // sega, rega, reta, rita, riba
	['tižė', 'lyja', 6], // ližė, lipė, lipi, lypi, lyji, lyja
	['augo', 'sėmė', 6], // augę, mugę, mėgę, mėmę, mėmė, sėmė
	['vyža', 'laso', 5], // vyžk, lyžk, lyžo, lažo, laso
	['ugdo', 'būti', 5], // uodo, bodo, būdo, būto, būti
	['puma', 'žižė', 6], // pupa, lupa, lipa, lipė, ližė, žižė
	['eglė', 'kaso', 6], // eilė, žilė, žalė, kalė, kasė, kaso
	['šuto', 'tūpė', 6], // kuto, kupo, kepo, kepė, tepė, tūpė
	['dega', 'mėžė', 5], // degė, dygė, dyžė, dėžė, mėžė
	['žyla', 'dūrė', 4], // dyla, dūla, dūlė, dūrė
	['kilo', 'žyra', 4], // žilo, žila, žyla, žyra
	['tilo', 'ložė', 4], // tižo, tižė, ližė, ložė
	['sesė', 'riba', 6], // segė, sega, rega, reta, rita, riba
	['eilė', 'tyso', 5], // žilė, žilo, tilo, tiso, tyso
	['salo', 'vora', 4], // valo, varo, voro, vora
	['pala', 'ložė', 5], // lala, laka, lakė, lokė, ložė
	['maga', 'pynė', 4], // mana, manė, mynė, pynė
	['dygi', 'gana', 4], // dagi, gagi, gani, gana
	['lesė', 'dūda', 5], // lesą, ledą, dedą, deda, dūda
	['balo', 'metė', 4], // bato, mato, matė, metė
	['audė', 'bėga', 5], // budė, burė, bėrė, bėra, bėga
	['kupė', 'šoka', 5], // kopė, kovė, kova, šova, šoka
	['lopo', 'sala', 4], // sopo, solo, salo, sala
	['meta', 'gydė', 5], // metą, getą, gytą, gydą, gydė
	['rūda', 'menk', 5], // rūta, reta, meta, mena, menk
	['sofa', 'tynė', 7], // sora, dora, dori, dyri, tyri, tyni, tynė
	['lėkė', 'neva', 5], // lakė, laka, lava, nava, neva
	['oazė', 'tiki', 6], // bazė, barė, tarė, tari, tiri, tiki
	['nagi', 'ardo', 6], // ragi, radi, rudi, audi, ardi, ardo
	['kaba', 'tūžo', 5], // kabo, labo, lažo, lūžo, tūžo
	['šakė', 'rūgo', 4], // rakė, ragė, rago, rūgo
	['gėlė', 'supa', 4], // gėla, gula, sula, supa
	['mina', 'lopė', 5], // minų, linų, lipų, lopų, lopė
	['kepė', 'sėjo', 6], // kekė, sekė, seko, seto, sėto, sėjo
	['kekė', 'toga', 6], // sekė, seka, sena, tena, tona, toga
	['supa', 'kaži', 4], // kupa, kuža, kuži, kaži
	['viza', 'kėlė', 5], // vila, žila, žilė, žėlė, kėlė
	['vylė', 'meta', 5], // vylu, mylu, melu, metu, meta
	['popa', 'rėžė', 5], // kopa, kopė, ropė, rožė, rėžė
	['ravi', 'mėmė', 5], // rami, romi, romė, rėmė, mėmė
	['vagi', 'arda', 6], // vadi, vadų, vidų, aidų, aida, arda
	['rūpi', 'bara', 5], // tūpi, tūri, tari, tara, bara
	['rūgi', 'mova', 5], // ragi, ravi, rovi, movi, mova
	['vėmė', 'tįsa', 6], // vėmi, vėsi, lėsi, lįsi, tįsi, tįsa
	['kito', 'tynė', 5], // kiro, tiro, tyro, tyrė, tynė
	['zylė', 'daga', 6], // vylė, vylu, dylu, dygu, dagu, daga
	['para', 'kūlė', 4], // pala, kala, kalė, kūlė
	['lūpa', 'rėžė', 5], // rūpa, rūpi, rėpi, rėži, rėžė
	['alga', 'virė', 7], // auga, guga, gugs, gurs, girs, virs, virė
	['alfa', 'teko', 6], // alka, auka, suka, seka, seko, teko
	['kūlė', 'pina', 5], // kalė, kala, pala, pila, pina
	['nešė', 'moto', 6], // pešė, pelė, pelo, melo, molo, moto
	['peri', 'lėkė', 5], // pūri, pūki, lūki, lėki, lėkė
	['gija', 'žydė', 5], // gijo, gido, gydo, žydo, žydė
	['tarp', 'ligi', 5], // tari, mari, magi, migi, ligi
	['laja', 'tiki', 5], // raja, raji, raki, riki, tiki
	['lopė', 'šuva', 5], // lopą, lovą, šovą, šuvą, šuva
	['vėrė', 'aižo', 5], // vėpė, vėpo, vipo, aipo, aižo
	['seno', 'gėla', 5], // meno, melo, mėlo, gėlo, gėla
	['vora', 'pyni', 5], // pora, porą, poną, poni, pyni
	['lošė', 'mena', 6], // lokė, mokė, moko, meko, meno, mena
	['tūžo', 'eilė', 5], // tižo, tilo, žilo, žilė, eilė
	['tašo', 'relė', 5], // pašo, palo, pelo, pelė, relė
	['sopa', 'menk', 5], // sopk, supk, sunk, senk, menk
	['kėlė', 'rūgo', 5], // kūlė, kūkė, rūkė, rūko, rūgo
	['šašo', 'tyli', 5], // lašo, laši, lali, tali, tyli
	['kibo', 'tyna', 4], // kino, tino, tina, tyna
	['volė', 'buko', 5], // volo, valo, balo, bako, buko
	['sega', 'žavi', 4], // saga, sava, savi, žavi
	['gobė', 'lydo', 5], // gobę, lobę, lodę, lydę, lydo
	['biro', 'anka', 6], // kiro, kuro, kuko, kuka, auka, anka
	['kopė', 'lūžo', 5], // kopą, kūpą, lūpą, lūžą, lūžo
	['gana', 'filė', 4], // ganė, ginė, gilė, filė
	['šėlo', 'sopa', 5], // šėpo, lėpo, lopo, sopo, sopa
	['duja', 'cypė', 7], // duji, duši, dyši, čyši, čypi, cypi, cypė
	['auna', 'noro', 6], // aura, aure, bure, bore, nore, noro
	['vėso', 'raja', 5], // vėto, vato, vata, rata, raja
	['ardo', 'teka', 6], // arda, arka, auka, suka, seka, teka
	['tašė', 'ryti', 5], // rašė, rašo, rato, ryto, ryti
	['joja', 'ardo', 6], // jota, juta, auta, arta, arto, ardo
	['žėri', 'lepo', 5], // žeri, keri, kepi, lepi, lepo
	['varu', 'ližė', 5], // vapu, lapu, lipu, lipė, ližė
	['kero', 'vada', 4], // karo, varo, vado, vada
	['lupa', 'tolo', 5], // lupi, tupi, tuli, toli, tolo
	['rado', 'duba', 5], // rudo, gudo, gubo, guba, duba
	['žala', 'lypi', 5], // žali, žagi, žygi, lygi, lypi
	['ardė', 'rimo', 5], // ardo, aido, kido, kimo, rimo
	['ligi', 'gobė', 5], // liti, loti, lobi, gobi, gobė
	['vata', 'kimo', 5], // rata, rato, rito, rimo, kimo
	['vėlė', 'gydo', 4], // gėlė, gylė, gydė, gydo
	['tūba', 'lodo', 6], // tūbą, rūbą, rūdą, rodą, lodą, lodo
	['tarė', 'viso', 5], // barė, baro, biro, biso, viso
	['zujo', 'saga', 5], // zuja, guja, gaja, gaga, saga
	['mini', 'rudo', 5], // aini, aidi, ridi, rudi, rudo
	['budi', 'gimė', 4], // budė, gudė, gidė, gimė
	['pats', 'tona', 5], // patų, panų, ponų, tonų, tona
	['lygė', 'sija', 4], // lyga, lyja, syja, sija
	['dyla', 'joti', 5], // dyli, myli, moli, moti, joti
	['movi', 'sala', 4], // moli, mali, mala, sala
	['lepo', 'žolė', 5], // lopo, lopė, ropė, rolė, žolė
	['rito', 'vėmė', 4], // rimo, rėmo, rėmė, vėmė
	['bėgo', 'šakė', 6], // mėgo, mago, magė, sagė, sakė, šakė
	['puro', 'davė', 5], // pužo, dužo, dažo, dažė, davė
	['mala', 'vyko', 5], // pala, palo, pako, pyko, vyko
	['zykė', 'peša', 5], // zylė, pylė, pelė, pešė, peša
	['vaza', 'tąsė', 6], // viza, visa, viso, tiso, tąso, tąsė
	['kala', 'teko', 5], // sala, salo, sako, seko, teko
	['moja', 'rūgi', 6], // moka, moko, roko, rūko, rūgo, rūgi
	['daro', 'arfa', 7], // dari, diri, didi, aidi, ardi, arda, arfa
	['relė', 'šoka', 5], // rolė, molė, mokė, moka, šoka
	['veto', 'lyga', 4], // vyto, lyto, lygo, lyga
	['loja', 'nešė', 5], // laja, laša, naša, neša, nešė
	['dūda', 'kovė', 5], // rūda, rūdė, rodė, rovė, kovė
	['tūpė', 'žino', 5], // tapė, tapo, tano, tino, žino
	['įarė', 'lypi', 6], // įari, gari, gaji, laji, lyji, lypi
	['saga', 'pešė', 5], // sagė, ragė, rašė, pašė, pešė
	['arda', 'movi', 6], // aida, rida, ridi, rodi, rovi, movi
	['kiša', 'gylė', 5], // kyša, kyla, pyla, pylė, gylė
	['metė', 'kopa', 4], // meta, keta, kepa, kopa
	['uola', 'vypo', 6], // uolu, volu, vylu, vynu, vyno, vypo
	['būgo', 'dėžė', 6], // būro, bėro, bėrė, vėrė, vėžė, dėžė
	['būva', 'vėpo', 6], // būta, būto, bato, vato, vėto, vėpo
	['gedi', 'dėro', 5], // dedi, dydi, dyri, dyro, dėro
	['fazė', 'joga', 7], // bazė, baze, bate, bote, jote, jota, joga
	['rolė', 'teta', 5], // molė, motė, metė, meta, teta
	['koja', 'šipo', 5], // loja, lojo, lopo, lipo, šipo
	['žada', 'lošė', 6], // žadi, žydi, lydi, lyši, loši, lošė
	['ložė', 'niša', 6], // ložę, lošę, košę, kišę, kiša, niša
	['mėlo', 'lokė', 4], // molo, molė, mokė, lokė
	['laka', 'gedi', 5], // laki, lali, gali, geli, gedi
	['juto', 'bėgi', 5], // buto, būto, būgo, bėgo, bėgi
	['vėžė', 'laka', 5], // rėžė, rėkė, rakė, raka, laka
	['tiki', 'lodė', 5], // tikę, likę, lokę, lokė, lodė
	['myli', 'figa', 5], // mygi, lygi, ligi, liga, figa
	['šukė', 'būti', 5], // bukė, buku, butu, būtu, būti
	['šaka', 'degė', 5], // šakė, sakė, sekė, segė, degė
	['šalo', 'gena', 4], // galo, gano, gana, gena
	['pūtė', 'suma', 4], // pūta, puta, puma, suma
	['tyna', 'būrė', 5], // tynė, tyrė, tarė, barė, būrė
	['liga', 'dužo', 6], // lyga, lygo, lyžo, lažo, dažo, dužo
	['korė', 'dažo', 4], // karė, darė, dažė, dažo
	['lobo', 'kupė', 4], // lopo, lopė, kopė, kupė
	['vapa', 'uodė', 6], // vada, vadę, radę, rodę, uodę, uodė
	['tąsė', 'sėdi', 5], // tąsi, kąsi, kėsi, sėsi, sėdi
	['laša', 'rovė', 5], // lava, lova, mova, movė, rovė
	['nota', 'tiki', 5], // notų, nokų, noki, niki, tiki
	['kasė', 'bėga', 5], // basė, barė, bėrė, bėra, bėga
	['gena', 'kovė', 5], // gana, kana, kava, kova, kovė
	['gėla', 'ugdo', 5], // gėda, goda, godo, uodo, ugdo
	['lydo', 'puta', 5], // pydo, pūdo, pūto, puto, puta
	['sėjo', 'veda', 5], // vėjo, vėju, veju, vedu, veda
	['valo', 'teža', 5], // vado, vada, veda, veža, teža
	['solo', 'rėkė', 5], // salo, salė, sakė, rakė, rėkė
	['runa', 'vadė', 5], // ruja, raja, vaja, vada, vadė
	['būrė', 'zona', 6], // būrų, borų, porų, ponų, zonų, zona
	['dėmė', 'šoka', 5], // domė, domų, dokų, šokų, šoka
	['halė', 'muša', 4], // malė, mala, mula, muša
	['kada', 'jojo', 5], // kapa, kopa, koja, joja, jojo
	['virš', 'matė', 5], // mirš, marš, maro, mato, matė
	['gedo', 'mūvi', 5], // gedi, geri, gūri, mūri, mūvi
	['tuso', 'relė', 6], // tusi, tesi, vesi, veli, velė, relė
	['ūkia', 'asas', 5], // ūkis, akis, akus, asus, asas
	['žiba', 'šėlo', 4], // žila, žilo, šilo, šėlo
	['rodo', 'sėmė', 4], // romo, rėmo, rėmė, sėmė
	['barė', 'žūti', 5], // barų, batų, būtų, būti, žūti
	['mišo', 'kopa', 5], // kišo, kišt, košt, kopt, kopa
	['ližė', 'pupa', 4], // lipė, lipa, lupa, pupa
	['kimo', 'zuja', 6], // kimę, gimę, giję, guję, zuję, zuja
	['šuva', 'pūtė', 5], // šuvą, šutą, putą, pūtą, pūtė
	['lodo', 'rega', 6], // rodo, rado, rago, ragą, regą, rega
	['lova', 'nižo', 5], // lota, loto, lito, nito, nižo
	['temo', 'sija', 5], // lemo, limo, lijo, sijo, sija
	['mūvi', 'rodė', 4], // movi, movė, rovė, rodė
	['žąla', 'mugė', 5], // žala, žalė, žagė, magė, mugė
	['pyni', 'kerė', 4], // peni, peri, keri, kerė
	['vila', 'pynė', 4], // pila, pyla, pylė, pynė
	['sūdė', 'šyla', 5], // pūdė, pydė, pylė, pyla, šyla
	['žilė', 'sėdi', 6], // žili, žyli, žysi, sysi, sėsi, sėdi
	['dėro', 'kūlė', 5], // dėrę, dėlę, dėlė, kėlė, kūlė
	['šipo', 'halė', 5], // šilo, šalo, šalę, halę, halė
	['riko', 'nagi', 4], // rako, rago, nago, nagi
	['mirė', 'arda', 6], // minė, minų, midų, aidų, ardų, arda
	['nori', 'mušė', 5], // nyri, myri, muri, muši, mušė
	['budė', 'šąla', 6], // gudė, gulė, gėlė, gėla, šėla, šąla
	['arfa', 'myli', 7], // arta, auta, autu, aulu, mulu, mylu, myli
	['tona', 'mirė', 4], // tina, mina, minė, mirė
	['noko', 'pypė', 5], // nokt, nykt, pykt, pypt, pypė
	['vožė', 'tįso', 6], // vežė, vežu, težu, tesu, tįsu, tįso
	['pupa', 'mini', 5], // pupt, pipt, pint, pini, mini
	['rėpė', 'kada', 5], // ropė, kopė, kopa, kapa, kada
	['lojo', 'žyra', 4], // loja, lyja, lyra, žyra
	['tyli', 'veša', 4], // vyli, vyši, veši, veša
	['virė', 'muša', 4], // mirė, mišė, mušė, muša
	['valė', 'žiro', 4], // žalė, žilė, žilo, žiro
	['mova', 'pynė', 5], // movė, mokė, mykė, mynė, pynė
	['ruja', 'salo', 5], // raja, laja, lala, sala, salo
	['jėga', 'rožė', 5], // joga, jogė, jovė, rovė, rožė
	['migo', 'tūba', 5], // milo, tilo, tūlo, tūbo, tūba
	['dužo', 'moka', 5], // dažo, mažo, mako, moko, moka
	['toga', 'rėžė', 6], // joga, jogė, vogė, vožė, vėžė, rėžė
	['mojo', 'žada', 5], // majo, mają, madą, žadą, žada
	['nižo', 'sopa', 6], // niro, siro, sirą, sorą, sopą, sopa
	['šėrė', 'lyti', 6], // žėrė, žėri, žyri, žygi, lygi, lyti
	['malė', 'pėda', 5], // malu, palu, padu, pėdu, pėda
	['lyti', 'mena', 5], // lytų, lynų, lenų, menų, mena
	['sako', 'pūra', 5], // pako, pakų, parų, pūrų, pūra
	['lyžo', 'rėpė', 4], // ryžo, rėžo, rėžė, rėpė
	['nors', 'duso', 5], // nori, dori, duri, dusi, duso
	['šąla', 'ložė', 6], // žąla, žila, žilė, žižė, ližė, ložė
	['pati', 'žydė', 5], // pato, pado, pydo, žydo, žydė
	['rašo', 'lypi', 4], // lašo, laši, lyši, lypi
	['pelė', 'sėti', 6], // velė, vėlė, vėtė, tėtė, tėti, sėti
	['neša', 'ryti', 5], // niša, riša, rita, ryta, ryti
	['vadė', 'teko', 5], // vado, bado, bako, tako, teko
	['gimė', 'alfa', 7], // gidė, gidą, aidą, ardą, arfą, alfą, alfa
	['žėrė', 'niša', 6], // žėri, žeri, neri, neši, neša, niša
	['dažo', 'sofa', 5], // daro, doro, dora, sora, sofa
	['fėja', 'jodo', 5], // sėja, soja, joja, jojo, jodo
	['žino', 'pūra', 5], // pino, peno, pero, pūro, pūra
	['žydė', 'rimo', 4], // žydo, rydo, rymo, rimo
	['rako', 'nori', 4], // roko, noko, noro, nori
	['dėti', 'movė', 4], // mėti, moti, motė, movė
	['kaso', 'bitė', 4], // baso, bato, bito, bitė
	['joga', 'senė', 5], // toga, tona, tena, sena, senė
	['celė', 'runa', 6], // relė, rolė, rodė, rudė, ruda, runa
	['geso', 'mynė', 4], // geno, meno, menė, mynė
	['aižo', 'kyla', 6], // tižo, tino, tina, tyna, tyla, kyla
	['sala', 'lodo', 4], // salo, solo, sodo, lodo
	['įavė', 'rūpi', 5], // įavi, ravi, ragi, rūgi, rūpi
	['rimo', 'laša', 4], // rišo, rašo, lašo, laša
	['pynė', 'mojo', 5], // mynė, mykė, mokė, moko, mojo
	['bara', 'pelė', 5], // barų, parų, perų, pelų, pelė
	['mažo', 'rūta', 4], // mato, rato, rata, rūta
	['guli', 'rėžė', 5], // gulė, gėlė, dėlė, dėžė, rėžė
	['arka', 'rėžė', 7], // auka, kuka, kukt, rukt, rėkt, rėžt, rėžė
	['vada', 'žynė', 5], // žada, žade, žyde, žyne, žynė
	['šova', 'rėmė', 4], // šovė, rovė, romė, rėmė
	['žymi', 'lapė', 5], // žysi, lysi, lysė, lasė, lapė
	['deja', 'mėgo', 5], // dega, degs, megs, mėgs, mėgo
	['tuko', 'ložė', 5], // tako, lako, lakė, lokė, ložė
	['daga', 'žymi', 4], // dagi, žagi, žygi, žymi
	['šoko', 'nata', 5], // roko, rako, rato, rata, nata
	['tąsa', 'sėjo', 6], // tąso, tiso, biso, bijo, sijo, sėjo
	['mėto', 'tona', 5], // meto, meta, teta, tena, tona
	['vyto', 'uodė', 5], // lyto, loto, lodo, uodo, uodė
	['sąla', 'neto', 6], // sala, salo, valo, vato, veto, neto
	['tįsa', 'vypo', 5], // tįso, tiso, tipo, vipo, vypo
	['gynė', 'šąla', 5], // gylė, gyli, šyli, šyla, šąla
	['vežė', 'žudo', 5], // vedė, vadė, vado, žado, žudo
	['lakė', 'uoga', 5], // lokė, vokė, vogė, uogė, uoga
	['žūti', 'vėmė', 6], // žūsi, dūsi, dėsi, dėmi, dėmė, vėmė
	['jūra', 'kupė', 6], // gūra, gura, gurk, kurk, kupk, kupė
	['tūta', 'goži', 5], // tūla, tūli, tūži, gūži, goži
	['šyla', 'nors', 6], // žyla, žila, žils, žirs, nirs, nors
	['kova', 'pūti', 5], // kovu, povu, pūvu, pūtu, pūti
	['mama', 'tižė', 6], // mana, mina, mini, tini, tiži, tižė
	['tąso', 'čeža', 5], // tąsi, tesi, teži, čeži, čeža
	['mėtė', 'lydi', 4], // mėti, lėti, lyti, lydi
	['tino', 'žėri', 5], // tiro, biro, bėro, bėri, žėri
	['gylė', 'vaza', 5], // galė, valė, vajė, vaja, vaza
	['zyzė', 'biro', 7], // zylė, gylė, gilė, žilė, žilo, žiro, biro
	['vokė', 'nagi', 4], // voki, vogi, vagi, nagi
	['dyri', 'laka', 5], // dari, dali, lali, laki, laka
	['rūta', 'davė', 6], // rata, rato, ražo, dažo, dažė, davė
	['guma', 'kopė', 5], // guža, kuža, kupa, kopa, kopė
	['gali', 'menė', 4], // gani, geni, meni, menė
	['jodo', 'eglė', 6], // godo, gido, gidė, gilė, eilė, eglė
	['dūja', 'geso', 5], // dūji, dūsi, gūsi, gesi, geso
	['buvo', 'tara', 5], // buto, bato, baro, bara, tara
	['pigo', 'veja', 6], // pino, peno, peną, veną, veją, veja
	['tįso', 'badė', 5], // tiso, biso, baso, basė, badė
	['lipo', 'dūrė', 6], // lipų, lirų, birų, būrų, būrė, dūrė
	['žavi', 'lopė', 5], // lavi, laki, lakė, lokė, lopė
	['žyra', 'čižo', 5], // nyra, nyro, niro, nižo, čižo
	['nėrė', 'kibo', 5], // narė, karė, kabė, kabo, kibo
	['rudo', 'manė', 5], // rudė, rusė, musė, masė, manė
	['tezė', 'vata', 5], // tepė, tepa, vepa, vapa, vata
	['ryžo', 'manė', 4], // ražo, mažo, mažė, manė
	['rėkė', 'gedi', 6], // rėmė, vėmė, vėmi, vemi, vedi, gedi
	['vedė', 'mini', 4], // vedi, medi, meni, mini
	['težo', 'supa', 5], // teko, seko, seka, suka, supa
	['noro', 'pūva', 4], // poro, pūro, pūra, pūva
	['žolė', 'rūta', 5], // rolė, rodė, rūdė, rūda, rūta
	['masė', 'tino', 4], // manė, mano, tano, tino
	['gilė', 'vada', 4], // galė, valė, vadė, vada
]